module.exports = __webpack_public_path__ + "static/media/dedo-ico.74e72240.png";